import { makeRequest } from "./api";

export const FetchPersonCapacity = async () => {
  return makeRequest("/api/admin/personCapacity/fetch");
};

export const UpdatePersonCapacity = async (
  itemName,
  otherItemName,
  startValue,
  endValue
) => {
  return makeRequest("/api/admin/personCapacity/update", {
    method: "PUT",
    data: {
      itemName,
      otherItemName,
      startValue,
      endValue,
    },
  });
};
